"use strict";

require("@polkadot/wasm-crypto/crypto-polyfill");